module.exports = require("@datastructures-js/max-heap");